import { useRef } from 'react';
import { toast } from 'sonner';
import { Camera, Trash2, ImagePlus, FileText } from 'lucide-react';
import { compressImage, uid } from '../lib/model';
import { objReportPdf, objTx } from '../lib/objReportPdf';

// photos attached directly to any object or pipe (camera or gallery, also afterwards) + report for this object only
export default function ObjPhotos({ t, obj, patch, project, kind }) {
  const cam = useRef(null), file = useRef(null), X = objTx();
  const list = obj.photos || [];
  const add = async (fs) => {
    const out = [];
    for (const f of fs) { try { out.push({ id: uid('op'), src: (await compressImage(f, 1600, 0.82)).data, at: Date.now() }); } catch { /* unreadable */ } }
    if (out.length) patch({ photos: [...list, ...out] });
  };
  const pick = (e) => { add([...e.target.files]); e.target.value = ''; };
  return (
    <div className="obj-photos" data-testid="obj-photos">
      <b>{t.dmPhotos} ({list.length})</b>
      <div className="obj-photos-row">
        {list.map((p) => (
          <span key={p.id} className="obj-photo"><img src={p.src} alt="" data-testid={`obj-photo-${p.id}`} title={p.at ? new Date(p.at).toLocaleString() : ''} />
            <button type="button" className="icon-btn danger" data-testid={`obj-photo-del-${p.id}`} onClick={() => patch({ photos: list.filter((x) => x.id !== p.id) })}><Trash2 size={12} /></button>
            <input className="obj-photo-note" data-testid={`obj-photo-note-${p.id}`} maxLength={120} placeholder={X.notePh} defaultValue={p.note || ''} onBlur={(e) => { const v = e.target.value.trim(); if (v !== (p.note || '')) patch({ photos: list.map((x) => (x.id === p.id ? { ...x, note: v } : x)) }); }} /></span>
        ))}
        <button type="button" className="btn btn-green btn-sm" data-testid="obj-photo-cam" onClick={() => cam.current.click()}><Camera size={14} /> {t.dmAddPhoto}</button>
        <button type="button" className="btn btn-outline btn-sm" data-testid="obj-photo-add" onClick={() => file.current.click()}><ImagePlus size={14} /></button>
        <input ref={cam} type="file" hidden accept="image/*" capture="environment" data-testid="obj-photo-cam-input" onChange={pick} />
        <input ref={file} type="file" hidden multiple accept="image/*" data-testid="obj-photo-input" onChange={pick} />
      </div>
      {project && <button type="button" className="btn btn-outline btn-sm" data-testid="obj-report-btn" onClick={() => objReportPdf(project, kind, obj, t).catch((e) => toast.error(String(e?.message || e)))}><FileText size={14} /> {X.title} (PDF)</button>}
    </div>
  );
}
